<!-- eslint-disable vue/require-prop-types -->
<template>
  <div class="btn-padding-0">
    <cs-button
      v-if="categoryName === undefined && !showViewPolicyLabel"
      id="btnViewPolicy"
      :primary="!showViewPolicyLabel"
      :disabled="elementDisabled"
      :label="showViewPolicyLabel ? 'View Policy' : 'View Excursion Policy'"
      @click="getData()"
    ></cs-button>
    <cs-button
      v-if="!(categoryName === undefined && !showViewPolicyLabel)"
      :id="viewPolicyBtnId"
      :disabled="elementDisabled"
      :loading="policyDisplayed"
      label="View Policy"
      @click="getData()"
    ></cs-button>
    <cs-form-dialog
      :id="dialogId"
      v-model="policyDisplayed"
      :body-id="dialogBodyId"
      heading="View Policy"
      :primary-action="{
        id: `${dialogBodyId}-close-btn`,
        label: 'Close',
        eventName: 'primary-click'
      }"
      @primary-click="policyDisplayed = false"
    >
      <template #cs-form-dialog-content>
        <v-alert
          v-if="markdownError"
          class="markdown-alert"
          variant="tonal"
          closable
          text="Apologies, there was an issue loading the content. Please refresh the page and try again."
        />
        <v-card v-if="policyDisplayed" variant="flat">
          <v-card-title class="view-policy-modalTitle">
            <cs-button
              v-if="activitySupervisorScrollDisplayed && content && content.length > 0"
              id="policy-view--supervisor-qualifications-display-button"
              label="Supervision Qualifications and Ratios"
              @click="turnToSupervisor"
            ></cs-button>
            <v-chip
              v-if="ratioChipDisplayed"
              id="view-policy--policy-display-dialog--ratio-chip-display-close--button"
              class="ratio-chip"
              closable
              color="#ff7f32"
              label
              variant="outlined"
              @click:close="ratioChipDisplayed = false"
              >Calculated Supervision Ratio - {{ getStaffToStudentRatio() }}</v-chip
            >
          </v-card-title>
          <v-divider class="modalDivider"></v-divider>
          <v-card-text id="policy" class="policy view-checklist-policy">
            <div v-if="!content || content.length <= 0" class="complete-loading">
              <v-progress-circular
                :size="70"
                color="rgb(29, 175, 236)"
                class="loading-img"
                indeterminate
              ></v-progress-circular>
            </div>
            <v-list v-for="(option, index) in content" id="policyList" :key="index">
              <stb-markdown
                class="policy-markdown"
                :source="option.Policy"
                @markdown-error="markdownError = true"
              ></stb-markdown>
            </v-list>
          </v-card-text>
        </v-card>
      </template>
    </cs-form-dialog>
  </div>
</template>

<script>
import * as types from '@/store/mutationTypes';
import riskCategoryLabel from '../lib/const/riskCategoryLabel';
import StbMarkdown from './StbMarkdown';

export default {
  name: 'ViewPolicy',

  components: {
    StbMarkdown
  },
  props: [
    'categoryName',
    'riskTypeName',
    'riskClassName',
    'riskName',
    'elementDisabled',
    'showViewPolicyLabel',
    'activitySupervisorScrollDisplayed',
    'masterPolicyExported',
    'excursionPolicyExported',
    'buttonId'
  ],
  data: () => ({
    ratioChipDisplayed: false,
    policyDisplayed: false,
    content: [],
    masterPolicyRiskCategory: ['Master Excursions Policy'],
    markdownError: false
  }),
  computed: {
    activityTlrcName() {
      // tlrc stands for: top level risk category
      return riskCategoryLabel.ACTIVITIES;
    },
    allSelectedActivityRisk() {
      return this.$store.getters['common/getSelectedActivityClasses'][0];
    },
    viewPolicyBtnId() {
      if (this.buttonId) {
        return this.buttonId;
      }

      let idViewPolicy;

      if (typeof this.categoryName !== 'undefined') {
        idViewPolicy = `btnViewPolicy${this.categoryName.replace(/\s/g, '')}`;
      }

      if (typeof this.riskTypeName !== 'undefined' && typeof this.riskClassName !== 'undefined') {
        idViewPolicy = `btnViewPolicy${this.riskTypeName.replace(
          /\s/g,
          ''
        )}${this.riskClassName.replace(/\s/g, '')}`;
      }

      if (!idViewPolicy) {
        idViewPolicy = 'btnViewPolicyUndefined';
      }

      return idViewPolicy;
    },
    dialogId() {
      return this.generateId('dlg-view-policy');
    },
    dialogBodyId() {
      return this.generateId('dlg-view-policy', 'body');
    }
  },
  updated() {
    const h1Elements = document.querySelectorAll('#policy h1');
    const h2Elements = document.querySelectorAll('#policy h2');
    const h3Elements = document.querySelectorAll('#policy h3');

    h1Elements.forEach((h1Element, index) => {
      h1Element.id = `view-policy-modal--h1-${index}`;
    });

    h2Elements.forEach((h2Element, index) => {
      h2Element.id = `view-policy-modal--h2-${index}`;
    });

    h3Elements.forEach((h3Element, index) => {
      h3Element.id = `view-policy-modal--h3-${index}`;
    });
  },
  methods: {
    generateId(base, suffix = '') {
      const parts = [this.categoryName, this.riskTypeName, this.riskClassName, this.riskName]
        .filter(Boolean)
        .map((part) => part.replace(/\s+/g, ''));
      return `${base}-${parts.join('-')}${suffix ? `-${suffix}` : ''}`;
    },

    getStaffToStudentRatio() {
      const { excursionDc } = this.$store.state.common;
      return this.$app.excursionCommon.getStaffToStudentRatio(
        excursionDc.staffSupervisorAttendanceCount,
        excursionDc.studentAttendanceCount
      );
    },
    turnToSupervisor() {
      const h3Elements = document.querySelectorAll('h3');
      const supervisorSelector = Array.from(h3Elements).find((el) =>
        el.textContent.includes('Supervisor Qualifications')
      );

      const supervisionSelector = Array.from(h3Elements).find((el) =>
        el.textContent.includes('Supervision Ratios')
      );

      if (supervisorSelector) supervisorSelector.style.color = 'rgb(29, 175, 236)';
      if (supervisionSelector) supervisionSelector.style.color = 'rgb(29, 175, 236)';

      const policyListSelector = document.getElementById('policyList');

      if (supervisorSelector && policyListSelector) {
        const supervisorTop = supervisorSelector.getBoundingClientRect().top;
        const policyListTop = policyListSelector.getBoundingClientRect().top;

        const policyElement = document.getElementById(this.dialogBodyId);
        const policyDialogContent = policyElement.querySelector('div.cs-form-dialog-content');

        if (policyDialogContent) {
          policyDialogContent.scrollTop = supervisorTop - policyListTop + 30;
        }
      }

      this.ratioChipDisplayed = true;
    },
    async getData() {
      this.ratioChipDisplayed = true;
      this.content = [];
      this.policyDisplayed = true;
      const that = this;

      if (this.categoryName === undefined) {
        const riskCategories = this.$store.state.common.excursionDc.categories.filter(
          (tlrc) => `${tlrc.name}` !== `${that.activityTlrcName}`
        );
        const paramRiskCategories = this.generateAllParams(riskCategories);
        if (this.masterPolicyExported) {
          paramRiskCategories.push(this.masterPolicyRiskCategory);
        }

        const argHash = {
          queryParam: this.$route.query,
          store: this.$store,
          frcs: paramRiskCategories
        };

        const apiResponse = await this.$app.stbApiAdapter.getViewPolicy(argHash);
        const { mandatory } = apiResponse;
        const { optional } = apiResponse;
        const excursionName = that.$store.state.common.excursionDc.name;
        let headerName = `${excursionName} - Excursion Policy`;
        if (that.masterPolicyExported) {
          that.$store.commit(types.COMMON_SET_CE_COMMIT_OID, apiResponse.ceCommitOid);
          headerName = `Master Excursions Policy`;
        }
        if (mandatory && mandatory.length && mandatory[0].Policy) {
          mandatory[0].Policy = mandatory[0].Policy.replace(
            that.masterPolicyRiskCategory[0],
            `${headerName}`
          );
        }
        that.content = mandatory.concat(optional);
      } else if (
        typeof this.categoryName !== 'undefined' &&
        undefined === this.riskTypeName &&
        undefined === this.riskClassName
      ) {
        const recordedTlrc = this.$store.state.common.excursionDc.categories.find(
          (tlrc) => tlrc.name === this.categoryName
        );

        let paramRiskCategories = [];

        if (this.categoryName !== that.activityTlrcName) {
          paramRiskCategories = this.generateParams(recordedTlrc);
        } else {
          paramRiskCategories = this.generateParams(this.allSelectedActivityRisk);
        }

        if (paramRiskCategories.length === 0) {
          const paramRiskCategory = [recordedTlrc.name];
          paramRiskCategories.push(paramRiskCategory);
        }

        const argHash = {
          queryParam: this.$route.query,
          store: this.$store,
          frcs: paramRiskCategories
        };

        const apiResponse = await this.$app.stbApiAdapter.getViewPolicy(argHash);
        const { optional } = apiResponse;
        this.content = optional;
        this.$store.commit(types.COMMON_SET_CE_COMMIT_OID, apiResponse.ceCommitOid);
      } else {
        const riskType = this.$app.enumerable
          .from(this.allSelectedActivityRisk.types)
          .firstOrDefault((x) => x.name === this.riskTypeName);

        const riskClass = this.$app.enumerable
          .from(riskType.classes)
          .firstOrDefault((x) => x.name === this.riskClassName);

        const frcs = [];

        for (let riskKey = 0; riskKey < riskClass.risks.length; riskKey += 1) {
          const riskName = riskClass.risks[riskKey].name;
          const paramRiskCategory = [
            this.activityTlrcName,
            riskType.name,
            riskClass.name,
            riskName
          ];
          frcs.push(paramRiskCategory);
        }

        if (frcs.length > 0) {
          const argHash = {
            queryParam: this.$route.query,
            store: this.$store,
            frcs
          };
          const response = await this.$app.stbApiAdapter.getViewPolicy(argHash);
          const { optional } = response;
          this.content = optional;
          this.$store.commit(types.COMMON_SET_CE_COMMIT_OID, response.ceCommitOid);
        }
      }
    },
    generateParams(riskCategory) {
      const paramRiskCategories = [];
      const { activityTlrcName } = this;
      if (riskCategory.name !== activityTlrcName) {
        riskCategory.types.forEach((riskType) => {
          riskType.classes.forEach((riskClass) => {
            const paramRiskCategory = [riskCategory.name, riskType.name, riskClass.name];
            paramRiskCategories.push(paramRiskCategory);
          });
        });
      } else {
        riskCategory.types.forEach((riskType) => {
          riskType.classes.forEach((riskClass) => {
            for (let riskKey = 0; riskKey < riskClass.risks.length; riskKey += 1) {
              const riskName = riskClass.risks[riskKey].name;
              const paramRiskCategory = [activityTlrcName, riskType.name, riskClass.name, riskName];
              paramRiskCategories.push(paramRiskCategory);
            }
          });
        });
      }
      return paramRiskCategories;
    },
    generateAllParams(riskCategories) {
      const paramRiskCategories = [];
      const { activityTlrcName } = this;

      riskCategories.forEach((category) => {
        category.types.forEach((riskType) => {
          riskType.classes.forEach((riskClass) => {
            const paramRiskCategory = [category.name, riskType.name, riskClass.name];
            paramRiskCategories.push(paramRiskCategory);
          });
        });
      });
      if (typeof this.allSelectedActivityRisk !== 'undefined') {
        this.allSelectedActivityRisk.types.forEach((riskType) => {
          riskType.classes.forEach((riskClass) => {
            for (let riskKey = 0; riskKey < riskClass.risks.length; riskKey += 1) {
              const riskName = riskClass.risks[riskKey].name;
              const paramRiskCategory = [activityTlrcName, riskType.name, riskClass.name, riskName];
              paramRiskCategories.push(paramRiskCategory);
            }
          });
        });
      }
      return paramRiskCategories;
    }
  }
};
</script>
<style scoped>
.view-policy-modalTitle {
  padding: 18px;
  padding-left: 20px;
  font-size: 16px;
}

.ratio-chip {
  height: 30px;
  margin: 4px 0 0 8px;
}

.policy-markdown,
:deep(.policy-markdown h1),
:deep(.policy-markdown h2),
:deep(.policy-markdown h3),
:deep(.policy-markdown p) {
  font-family: 'Roboto';
}

:deep(.policy-markdown h1) {
  color: gray;
  border-bottom: 3px solid #ff7f32;
  width: 100%;
}

:deep(.policy-markdown h2) {
  color: #ff7f32;
  margin-top: 8px;
  margin-bottom: 8px;
}

:deep(.policy-markdown p) {
  margin-bottom: 12px !important;
}

:deep(.policy-markdown ul) {
  padding-left: 8px;
  margin-left: 20px;
  margin-bottom: 15px;
}

:deep(.policy-markdown li > p) {
  margin-bottom: 0px !important;
}

.disabled {
  color: rgba(0, 0, 0, 0.26) !important;
}

.sub-category-view-policy {
  margin-right: 48px;
}

.markdown-alert {
  color: #c80063;
  margin-bottom: 15px;
}

.view-checklist-policy .v-list-item__content label {
  margin-bottom: 5px;
}
</style>
